// A altura comum aos tres cabecalhos de coluna do visualizador de conversas
// (lista, transcricao, contacto). E UMA regra de 1px que atravessa a folha
// inteira, e e ela que diz que as tres colunas sao um objeto so; os tres
// componentes tem de a partilhar ou a linha parte-se a meio.
//
// Vive num modulo proprio porque a concha importa a transcricao e o painel, e
// qualquer um deles a importar a concha de volta fazia um ciclo.
export const COLUMN_HEADER_CLASS =
  "flex items-center h-14 px-4 shrink-0 border-b border-[var(--color-border)]";

// A etiqueta pequena com contorno da linha da lista de conversas (o nome do chat, a marca Bot).
// Quem a usa acrescenta a altura de linha e o que o distingue, como o `max-w` e o `truncate` do nome.
export const ROW_TAG_CLASS =
  "shrink-0 text-[11px] font-medium px-1.5 rounded border border-[var(--color-border)]";
